import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "filter",
  "use": "filter-usage",
  "viewBox": "6.38 9.19 23.25 17.56",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"6.38 9.19 23.25 17.56\" id=\"filter\"><path fill=\"currentColor\" d=\"M23.25 22.992a1.875 1.875 0 1 1 0 3.75h-10.5a1.875 1.875 0 0 1 0-3.75zm1.5-6.84a1.875 1.875 0 1 1 0 3.75h-13.5a1.875 1.875 0 0 1 0-3.75zm3-6.966a1.875 1.875 0 1 1 0 3.75H8.25a1.875 1.875 0 1 1 0-3.75z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol